import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PublicAccountSearchProvider } from './context/public-account-search-context';
import { PublicAccountSearchComponent } from './public-account-search-component';

export function PublicAccountSearchFactory() {
    return (
        <BaseLayoutFactory>
            <PublicAccountSearchProvider>
                <PublicAccountSearchComponent />
            </PublicAccountSearchProvider>
        </BaseLayoutFactory>
    );
}
